export const resumeLink = 'https://drive.google.com/file/d/1QkcGBN9o2FO8X6FFYIb6uMCKk5CIoo57/view?usp=drive_link';

export const emailLink = 'mailto:kiet.pha99@gmail.com';
export const linkedinLink = 'https://www.linkedin.com/in/kiet-pham-12916222a/';
export const githubLink = 'https://github.com/kietpha19';
export const facebookLink = 'https://www.facebook.com/phamhoanganh.kiet.5';
